import React from 'react';
import Dashboard from '../Dashboard';
import OtherInfoMain from './OtherInfoMain'

export default function OtherInfo() {
    return (
        <div>
            <Dashboard cmp={<OtherInfoMain />} />
        </div>
    )
}

